import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { UserCoursesSectionHeader } from 'src/user/courses/components/UserCoursesSectionHeader';
import { UserCoursesSectionTitle } from 'src/user/courses/components/UserCoursesSectionTitle';
import { CourseCardSkeleton } from 'src/common/components/CourseCardSkeleton';
import { UserCoursesContinueLearningItems } from 'src/user/courses/components/UserCoursesContinueLearning/UserCoursesContinueLearningItems';
import { useCurrentUserOngoingElearningsQuery } from 'src/common/hooks/elearning/useCurrentUserOngoingElearningsQuery';
import { mapToCourseExcerpt } from 'src/common/models/elearningProgress';
import { UserCoursesCards } from 'src/user/courses/components/UserCoursesCards';
import { range } from 'ramda';

const Container = styled.div`
  padding: 3.25rem 0 1.25rem;

  ${media.w.min.px768(css`
    padding-top: 3.75rem;
  `)};
`;

export const UserCoursesContinueLearning = () => {
  const { data, isFetching } = useCurrentUserOngoingElearningsQuery();

  const items = useMemo(() => data && data.map((item) => mapToCourseExcerpt(item)), [data]);

  if (!isFetching && (!items || items.length === 0)) {
    return null;
  }

  return (
    <Container>
      <UserCoursesSectionHeader>
        <UserCoursesSectionTitle>Kontynuuj naukę</UserCoursesSectionTitle>
      </UserCoursesSectionHeader>

      {isFetching && (
        <UserCoursesCards>
          {range(0, 4).map((i) => (
            <CourseCardSkeleton key={i} />
          ))}
        </UserCoursesCards>
      )}

      {!isFetching && items && <UserCoursesContinueLearningItems items={items} />}
    </Container>
  );
};
